module.exports = __webpack_public_path__ + "img/data_use.08202d30.png";